import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MiniPricerWidgetComponent} from './component/mini-pricer-widget/mini-pricer-widget.component';
import { MiniPricerIframeComponent } from './component/mini-pricer-iframe/mini-pricer-iframe.component';
import { MiniPricerGraphComponent } from './component/mini-pricer-graph/mini-pricer-graph.component';
import { MortgageCalculatorComponent } from './component/mortgage-calculator/mortgage-calculator.component';
import { AffordabilityCalculatorComponent } from './component/affordability-calculator/affordability-calculator.component';
import { MortgagePricerComponent } from './component/mortgage-pricer/mortgage-pricer.component';
import { MortgagePricerOriginalTemplateComponent } from './component/mortgage-pricer-original-template/mortgage-pricer-original-template.component';
import { PersonalizedQuoteComponent } from './component/mortgage-calculator/common/personalized-quote/personalized-quote.component';

const routes: Routes = [
  { path: 'pricing', component: MiniPricerIframeComponent },
  { path: 'mortgage-pricer', component: MortgagePricerComponent },
  { path: 'mortgage-pricer-original', component: MortgagePricerOriginalTemplateComponent },
  { path: 'ticker', component: MiniPricerWidgetComponent },
  { path: 'graph', component: MiniPricerGraphComponent },
  { path: 'mortgage-calculator', component: MortgageCalculatorComponent },
  { path: 'affordability-calculator', component: AffordabilityCalculatorComponent },
  {path: 'personalized-quote', component: PersonalizedQuoteComponent},
  { path: '', redirectTo: '/pricing', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})

export class AppRoutingModule { }

